// @ts-nocheck
import React, {
  useRef,
  useState,
  useEffect,
  useContext,
  useCallback,
} from 'react';
import { inject, observer } from 'mobx-react';
import { style as imageStyle, url as imageUrl } from 'utils/image';
import { ThemeContext } from 'store/ThemeProvider';

import request from '../../utils/request';
import ComponentLink from '../ComponentLink';
import RootStore from '../../store/RootStore';
import SearchRow from '../ComponentVote/Search';
import searchIcon from '../../assets/search.png';
import searchActiveIcon from '../../assets/search-active.png';

import './index.scss';
import { message } from 'components/Dialog/Toast';
import { Toast } from 'antd-mobile';

export interface IExhibitorItem {
  id: number;
  order_id: number;
  name: string;
  short_name: string;
  booth: string;
  desc: string;
  contact_person: string;
  contact_person_mobile: string;
  gallery_id: number;
  gallery_pagedata_id: number;
  exhibitor_logo: string | null;
  status: number;
  gallerys_detail?: any;
  gallerys_pagedata_detail?: any;
}

export interface IComponentExhibitor {
  cid: string;
  list?: IExhibitorItem[];
  search?: boolean;
  showList?: boolean;
  autoShowAll?: boolean;
  banner?: string;
  exhibitorOrder?: number[];
  container?: any;
  rootStore?: RootStore;
}

const PAGE_SIZE = 10;


export const searchSvg = (<svg t="1772606931184" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4774" width="200" height="200"><path d="M446.112323 177.545051c137.567677 0.219798 252.612525 104.59798 266.162424 241.493333 13.562828 136.895354-78.778182 261.818182-213.617777 289.008485-134.852525 27.203232-268.386263-52.156768-308.945455-183.608889s25.018182-272.252121 151.738182-325.779394A267.235556 267.235556 0 0 1 446.112323 177.545051m0-62.060607c-182.794343 0-330.989899 148.195556-330.989899 330.989899s148.195556 330.989899 330.989899 330.989899 330.989899-148.195556 330.989899-330.989899-148.195556-330.989899-330.989899-330.989899z m431.321212 793.341415a30.849293 30.849293 0 0 1-21.94101-9.102223l-157.220202-157.220202c-11.752727-12.179394-11.584646-31.534545 0.37495-43.50707 11.972525-11.972525 31.327677-12.140606 43.494141-0.37495l157.220202 157.220202a31.036768 31.036768 0 0 1 6.723232 33.810101 31.004444 31.004444 0 0 1-28.651313 19.174142z m0 0" p-id="4775"></path></svg>);


const ExhibitorItem: React.FC<{
  item: IExhibitorItem;
  onClick: (item: IExhibitorItem) => void;
  h1Color: string;
  h2Color: string;
}> = ({ item, onClick, h1Color, h2Color }) => {

  const exhibitorLogo = item.exhibitor_logo || 'attachment/877c3de980ac10b773d12a286f887ed6.png';

  const logoSrc = imageUrl(exhibitorLogo, {
        'x-oss-process':
          'image/resize,m_pad,w_400,h_400,color_ffffff/format,jpg',
      });

  return (
    <div className="exhibitor-item" onClick={() => onClick(item)}>
      <div className="exhibitor-logo">
        {logoSrc ? (
          <img src={logoSrc} alt={item.name} />
        ) : (
          <span className="logo-placeholder">展</span>
        )}
      </div>
      <div className="exhibitor-info">
        <div className="exhibitor-name" style={{ color: '#333' }}>
          {item.name || item.short_name || '未命名展商'}
        </div>
        <div className="exhibitor-booth" style={{ color: h2Color }}>
          展位：{item.booth || '-'}
        </div>
      </div>
      <div className="exhibitor-arrow">
        <svg viewBox="0 0 24 24" width="16" height="16">
          <path
            fill={h2Color}
            d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z"
          />
        </svg>
      </div>
    </div>
  );
};

/**
 * 请求展商列表接口
 */
const fetchExhibitorList = async (params: {
  order_id: string;
  page?: number;
  page_size?: number;
  name?: string;
  ids?: string;
  gallery_id?: string;
}) => {
  const data: any = {
    _with: 'gallerys_detail',
    page: params.page || 1,
    page_size: params.page_size || PAGE_SIZE,
    order_id: params.order_id,
    status: 1,
    //  !null=gallery_id
    "!null": 'gallery_id',
  };
  if (params.name) {
    data.name = params.name;
  }
  if (params.ids) {
    data.ids = params.ids;
    data.page_size = params.ids.split(',').length;
  }
  if (params.gallery_id) {
    data.gallery_id = params.gallery_id;
  }
  return request({
    url: `/api/v2/exhibitor/list`,
    method: 'GET',
    data,
  });
};

const AllForExhibitor: React.FC<IComponentExhibitor> = (props) => {
  const {
    cid,
    list = [],
    search = true,
    showList = true,
    autoShowAll = false,
    banner,
    exhibitorOrder = [],
    rootStore,
  } = props;

  const [exhibitors, setExhibitors] = useState<IExhibitorItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  // 搜索触发时是否已搜索过（控制 showList=false 时的列表显示）
  const [hasSearched, setHasSearched] = useState(false);

  const listRef = useRef<HTMLDivElement>(null);

  const { h1Color, h2Color, mainColor, componentColor } =
    useContext(ThemeContext);

  const orderId = window.gallery?.orderid;

  /**
   * 加载展商列表（支持分页追加）
   */
  const loadExhibitors = useCallback(
    async (pageNum: number, searchKeyword: string, append: boolean = false) => {
      if (!orderId) {
        setExhibitors([]);
        return;
      }
      setLoading(true);
      try {
        const res = await fetchExhibitorList({
          order_id: orderId,
          page: pageNum,
          page_size: PAGE_SIZE,
          name: searchKeyword || undefined,
        });
        if (res.code === 200 && res.data?.items) {
          let items = res.data.items.filter(
            (it: IExhibitorItem) => it.status === 1
          );
          const totalCount = res.data.total || 0;

          if (append) {
            setExhibitors((prev) => [...prev, ...items]);
          } else {
            // 自动模式下如果有排序顺序，按顺序排列
            if (
              autoShowAll &&
              !searchKeyword &&
              exhibitorOrder &&
              exhibitorOrder.length > 0
            ) {
              items = items.sort((a: IExhibitorItem, b: IExhibitorItem) => {
                const aIndex = exhibitorOrder.indexOf(a.id);
                const bIndex = exhibitorOrder.indexOf(b.id);
                if (aIndex === -1 && bIndex === -1) return 0;
                if (aIndex === -1) return 1;
                if (bIndex === -1) return -1;
                return aIndex - bIndex;
              });
            }
            setExhibitors(items);
          }

          setTotal(totalCount);
          setPage(pageNum);
          const loadedCount = append
            ? exhibitors.length + items.length
            : items.length;
          if (items.length === 0) {
            setHasMore(false);
          } else {
            setHasMore(loadedCount < totalCount);
          }
        } else {
          if (!append) setExhibitors([]);
          setHasMore(false);
        }
      } catch (e) {
        console.error('获取展商列表失败', e);
        if (!append) setExhibitors([]);
        setHasMore(false);
      } finally {
        setLoading(false);
      }
    },
    [orderId, autoShowAll, exhibitorOrder]
  );

  /**
   * 加载手动模式下通过 IDs 反查的展商
   */
  const loadExhibitorsByIds = useCallback(async () => {
    if (!list || list.length === 0 || !orderId) {
      setExhibitors([]);
      return;
    }
    setLoading(true);
    try {
      const ids = list.map((it: any) => it.id).join(',');
      const res = await fetchExhibitorList({
        order_id: orderId,
        ids,
      });
      if (res.code === 200 && res.data?.items) {
        const itemsMap: Record<number, IExhibitorItem> = {};
        res.data.items.forEach((item: IExhibitorItem) => {
          itemsMap[item.id] = item;
        });
        const orderedItems = list
          .map((it: any) => itemsMap[it.id])
          .filter((it: any) => !!it);
        setExhibitors(orderedItems);
        setTotal(orderedItems.length);
        setHasMore(false);
      } else {
        setExhibitors([]);
      }
    } catch (e) {
      console.error('获取展商列表失败', e);
      setExhibitors([]);
    } finally {
      setLoading(false);
    }
  }, [list, orderId]);

  // 初始化加载
  useEffect(() => {
    if (autoShowAll) {
      // 自动模式：从后端分页获取
      loadExhibitors(1, '');
    } else if (list && list.length > 0) {
      // 手动模式：根据 IDs 反查
      const hasFullData = list.some((it: any) => it.name || it.short_name);
      if (hasFullData) {
        setExhibitors(list);
        setTotal(list.length);
        setHasMore(false);
      } else {
        loadExhibitorsByIds();
      }
    } else {
      setExhibitors([]);
    }
  }, [autoShowAll, list, exhibitorOrder]);

  /**
   * 搜索
   */
  const onSearch = (value: string) => {
    setKeyword(value);
    setHasSearched(true);

    if (autoShowAll) {
      // 自动模式：后端搜索
      loadExhibitors(1, value);
    } else {
      // 手动模式：如果有搜索词，走后端搜索；否则显示手动列表
      if (value) {
        loadExhibitors(1, value);
      } else {
        // 清空搜索时恢复原列表
        loadExhibitorsByIds();
        setHasSearched(false);
      }
    }
  };

  /**
   * 滚动加载更多
   */
  const handleScroll = useCallback(
    (e: React.UIEvent<HTMLDivElement>) => {
      const { scrollTop, clientHeight, scrollHeight } = e.currentTarget;
      if (scrollHeight - scrollTop - clientHeight < 50) {
        if (!loading && hasMore) {
          loadExhibitors(page + 1, keyword, true);
        }
      }
    },
    [loading, hasMore, page, keyword, loadExhibitors]
  );

  const onExhibitorClick = (item: IExhibitorItem) => {
    const galleryLink = item.gallerys_detail?.link || '';
    const fromLinkId = window.pageDetail?.link_id || '';
    // const url = `/page/exhibitor/${item.id}?link=${galleryLink}&fromLinkId=${fromLinkId}&cid=${cid}`;
    const url = `/page/exhibitor/${item.id}?fromLinkId=${fromLinkId}&cid=${cid}`;
    console.log('跳转展商详情页', url);
    ComponentLink.to(url);
  };

  // showList 逻辑：
  // showList=true（默认）→ 始终显示列表
  // showList=false → 只显示搜索框，搜索后才显示结果
  const shouldShowList = showList || hasSearched;

  return (
    <div
      className="component-exhibitor-list"
      style={{ backgroundColor: componentColor }}
    >
      {search && (
        <div className="exhibitor-search">
            <div className="exhibitor-search-input">
            <div
              className="search-icon-img"
              onClick={() => {
              const inputEl = document.querySelector('.exhibitor-search-input input') as HTMLInputElement;
              if (inputEl) onSearch(inputEl.value);
              }}
              style={{ width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
              {React.cloneElement(searchSvg, { style: { width: '20px', height: '20px' } })}
            </div>
            <input
              placeholder="输入展商名、简称、展位号等关键词"
              onKeyDown={(e) => {
              if (e.key === 'Enter') onSearch((e.target as HTMLInputElement).value);
              }}
              onChange={(e) => {
              const val = e.target.value;
              if (!val) onSearch('');
              }}
            />
            </div>
        </div>
      )}

      {shouldShowList && (
        <div
          className="exhibitor-list"
          ref={listRef}
          onScroll={handleScroll}
          style={{
            maxHeight: showList ? undefined : '100vh',
            overflowY: showList ? undefined : 'auto',
          }}
        >
          {exhibitors.length === 0 && !loading ? (
            <div className="exhibitor-empty" style={{ color: h2Color }}>
              {hasSearched ? '未找到相关展商' : '暂无展商信息'}
            </div>
          ) : (
            exhibitors.map((item) => (
              <ExhibitorItem
                key={item.id}
                item={item}
                onClick={onExhibitorClick}
                h1Color={h1Color}
                h2Color={h2Color}
              />
            ))
          )}

          {loading && (
            <div className="exhibitor-loading" style={{ color: h2Color }}>
              加载中...
            </div>
          )}

          {!hasMore && exhibitors.length > 0 && !loading && (
            <div className="exhibitor-bottom-tip" style={{ color: h2Color }}>              
            共有 {total} 个展商              
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default inject('rootStore')(observer(AllForExhibitor));
